import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/domains';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 cursor-pointer mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-flashlight-fill text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl text-background-50 whitespace-nowrap">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              国内领先的独立资讯爆料平台，致力于为公众提供真实、深入的资讯内容。收藏本站，获取黑料网最新永久域名。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/entertainment" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">娱乐圈</Link>
              <Link to="/category/social" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">社会热点</Link>
              <Link to="/category/tech" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">科技数码</Link>
              <Link to="/category/finance" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">财经商业</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2">
              <a href="mailto:tips@heiliaowang.com" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-mail-line mr-2"></i>tips@heiliaowang.com
              </a>
              <span className="text-sm text-background-400 whitespace-nowrap">
                <i className="ri-phone-line mr-2"></i>010-8888-6666
              </span>
              <span className="text-sm text-background-400 whitespace-nowrap">
                <i className="ri-map-pin-line mr-2"></i>北京市朝阳区
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {currentYear} {siteInfo.name} 版权所有 | 黑料网永久域名
          </p>
          <div className="flex items-center gap-4 text-sm text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">使用条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}